import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import GiveGift from "../pages/gift/GiveGift";
import GiftCreated from "../pages/gift/GiftCreated";
import MyGifts from "../pages/gift/MyGifts";
import MyGift from "../pages/gift/MyGift";
import Dashboard from "../pages/dashboard/dashboard";
import Availability from "../pages/availability/availability";
import GoOnDemand from "../pages/medium/goOnDemand/goOnDemand";
import MediumAppointments from "../pages/medium/appointments";
import MyProfile from "../pages/medium/myprofile";
import Feedback from "../pages/medium/feedbacks";
import UrlSubmissionProfile from "../pages/medium/urlsubmission";
import Integration from "../pages/medium/integration";
import MediumView from "../pages/medium/myprofile/mediumprofileview";
import MyAvailability from "../pages/medium/availability";
import Transaction from "../pages/medium/transactions";
import Princing from "../pages/medium/princing";
import PayMyMedium from "../pages/paymymedium";
import ThankyouPopup from "../pages/client/appointment/premiumsessions/practitonerInfo/payment/thankyou";
import MediumBooking from "../pages/medium/booking";
import VerifyEmail from "../pages/admin/calendar/verifyemail";
import MediumProfileView from "../pages/medium/myprofile/mediumprofileview/profileview";
import CoachProfileView from "../pages/medium/myprofile/coachprofileview/profileview";
import AppointmentConfirm from "../pages/client/appointmentconfirm";
import ReferOthers from "../pages/medium/referothers";
import GoOnDemandPractice from "../pages/medium/goOnDemandPractice/goOnDemandPractice";
import MediumServiceEntry from "../pages/medium/serviceentry";
import ServiceEntryOptionOne from "../pages/medium/serviceentry/options/OptionOne";
import ServiceEntryOptionTwo from "../pages/medium/serviceentry/options/OptionTwo";
import ServiceEntryOptionLast from "../pages/medium/serviceentry/options/OptionLast";
import MediumImmediateOnDemand from "../pages/medium/immediateOnDemand/MediumImmediateOnDemand";
import BackFill from "../pages/medium/backfill";
import PayItForward from "../pages/medium/payitforward";
import BackFromMedium from "../pages/medium/backfillmediums/goOnDemandPractice/goOnDemandPractice";
import ClientAppointment from "../pages/client/appointment/appointment";
import Topbar from "../components/topbar/topbar";
import Overviewmedium from "../pages/overviewmedium";
import Media from "../pages/media/media";
import CheckInService from "../pages/checkinservice";
import OnboardingBooking from "../pages/onboardingbooking";

// import Survey from "../pages/surveyform";
// import Zoomhandler from "../pages/zoomhandler";

const MediumRouteApproved = () => {
  const [urlMedium, setUrlMedium] = useState(null);
  const { current_mediumship_level, provider, is_europe, id } = useSelector(
    (state) => state.user.user
  );
  useEffect(() => {
    if ((provider === "" || provider === null) && id == 15152) {
      setUrlMedium("appointments");
    } else {
      setUrlMedium("service-entry");
    }
  }, []);
  return (
    <Routes>
      {urlMedium && (
        <Route path="/" element={<Navigate to={`/${urlMedium}`} />} />
      )}
      <Route path="/public-view" element={<MediumView />} />
      {/* <Route path="/dashboard" element={<Dashboard />} /> */}
      <Route
        path="/public-view/:id"
        element={<MediumProfileView show={false} />}
      />
      <Route path="/verifyemail" element={<VerifyEmail />} />
      <Route path="/availability" element={<MyAvailability />} />
      <Route path="/sessions" element={<Availability />} />
      <Route path="/appointments" element={<MediumAppointments />} />
      <Route path="/my-profile" element={<MyProfile />} />
      <Route path="/go-on-demand" element={<GoOnDemand />} />
      <Route path="/go-on-demand-practice" element={<GoOnDemandPractice />} />
      <Route path="/service-entry" element={<MediumServiceEntry />} />
      {/* Booking Hub description prototypes for client review */}
      <Route path="/service-entry-optionone" element={<ServiceEntryOptionOne />} />
      <Route path="/service-entry-optionTwo" element={<ServiceEntryOptionTwo />} />
      <Route path="/service-entry-optionlast" element={<ServiceEntryOptionLast />} />
      <Route
        path="/go-on-demand-client"
        element={<MediumImmediateOnDemand />}
      />
      <Route path="/refer-others" element={<ReferOthers />} />
      <Route path="/feedbacks" element={<Feedback />} />
      <Route path="/integration" element={<Integration />} />
      <Route path="/transactions" element={<Transaction />} />
      <Route path="/pricing" element={<Princing />} />
      <Route path="/paymymedium/:id" element={<PayMyMedium />} />
      <Route path="/booking" element={<MediumBooking />} />
      <Route
        path="/onboarding-booking/:mediumId"
        element={<OnboardingBooking />}
      />
      <Route path="/thankyou" element={<ThankyouPopup />} />
      <Route
        path="/appointment-confirmation/:id"
        element={<AppointmentConfirm />}
      />
      <Route path="/backfill" element={<BackFill />} />
      <Route path="/pay-it-forward" element={<PayItForward />} />
      <Route path="/backfill-medium" element={<BackFromMedium />} />
      <Route path="/shortcuts" element={<Overviewmedium />} />
      {/* VerySoul Gift — purchaser side */}
      <Route path="/give-a-gift" element={<GiveGift />} />
      <Route path="/gift-created" element={<GiftCreated />} />
      <Route path="/my-gifts" element={<MyGifts />} />
      <Route path="/my-gifts/:id" element={<MyGift />} />
      <Route path="/mediums" element={<Media />} />
      <Route path="/clients" element={<Media />} />

      <Route path="/general-public" element={<Media />} />
      <Route path="/check-in-service" element={<CheckInService />} />
      <Route
        path="/coach-reviews/:id"
        element={<CoachProfileView show={false} />}
      />
      <Route
        path="/url-submission-profile"
        element={<UrlSubmissionProfile />}
      />
      {/* <Route path="/survey" element={<Survey />} /> */}
      <Route path="*" element={<Navigate to="/" />} />
      <Route
        path="/appointment"
        element={
          <div className="new-appointment new-appointment-listt">
            <Topbar />
            <ClientAppointment />
          </div>
        }
      />
    </Routes>
  );
};
export default MediumRouteApproved;
